/*!
 * e3-table JavaScript Library v0.0.63
 *
 * Released under the MIT license
 *
 * Date: 2020-08-10T15:36Z
 */

(function(global, factory) {

  if (typeof define === 'function' && define.amd) {
    define('e3-table', 
      ['jquery', 'underscore', 'vertebrae', 'bluebird', 'handlebars', 'moment', 'bootstrap'], factory);
  } else {
    factory((global.jQuery || global.$), global._, {}, global.Promise, global.Handlebars, global.moment);
  }

}(this, function($, _, Vertebrae, Promise, Handlebars, moment) {

  var TableView = Vertebrae.View.extend({

    templates: {
      'e3.table.init' : 'renderInitFragment',
      'e3.table.row'  : 'renderRowFragment'
    },

    events: {
      'click .e3-table-row-content'                : 'handleTableRowClick',
      'click .e3-table-header-cell'                : 'handleTableHeaderCell',
      'click .remove-icon-cell'                    : 'handleRemoveClick',
      'click .e3-table-min-header .dropdown li a'  : 'handleMinTableHeaderSortClick',
      'keyup .e3-table-min-header .dropdown li a'  : 'handleMinTableHeaderSortEnter'
    },

    render: function() {
      var delegate   = this.getDelegate(),
          properties = delegate.getTemplateProperties();

      this.renderBody(properties);
    },

    renderBody: function(properties) {
      this.$el.html(this.renderInitFragment(properties));
    },

    refreshItems: function() {
      var delegate   = this.getDelegate(),
          container  = this.getTableContainer(),
          items      = delegate.getProcessedItems(),
          showCount  = delegate.showGroupedItemsCount(),
          appendNew  = delegate.getFlag('appendNewData'),
          group      = null,
          text       = '',
          i          = 0,
          len        = items ? items.length : 0,
          groupingId = '';

      if (!appendNew) {
        container.empty();
      }

      if (len == 0) {
        if (delegate.getOption('emptyListTemplate') && !appendNew) {
          container.html(this.template(delegate.getOption('emptyListTemplate'), {colspan: delegate.columns.length}));
        }
      } else if (delegate.hasGroupedItems() && !appendNew) {
        for (i = 0; i < len; ++i) {
          group = items[i];
          text =  group.name;
          if (showCount) {
            text += ' (' + group.items.length + ')';
          }

          // define an HTML ID for the column spanning section header and set the headerAttr property of the groupings cells
          // so they can reference the correct reading order of headers, ie <group header> + <columnHeader>
          groupingId = delegate.getView().cid + 'Grouping_' + i;  // id for the group <th>
          group.items.forEach(function(item, index) {
            _.map(item.cells, function(cell) {
              cell.headersAttr = groupingId + ' ' + delegate.getView().cid + cell.column.name;  //group <th> header ID + column <th> header ID
            });
          });
          container.append('<tr class="e3-table-row-group"><th id="' + groupingId + '" colspan="' + delegate.getColumns().length +'" scope="colgroup">' + text + '</th></tr>');
          container.append(this.renderRowFragment(group.items, true));
        }

      } else {
        container.append(this.renderRowFragment(items, true));
      }

      // set CSS table striping on every other table row with data
      container.find('.e3-table-row:odd').addClass('striped');
      container
        .find('.clickable')
        .attr({
          tabindex: '0',
          role: 'button',
          'aria-label': 'Click row for more'
        })
      this.refreshTableScroll();

      return Promise.resolve(container.scrollTop(0).promise());
    },

    refreshTableScroll: function() {
      var container = this.getTableContainer().get(0),
          padding   = '';

      // Offset width by ScrollBar Width
      if (container && container.scrollHeight > container.clientHeight) {
        padding = this.getScrollBarWidth(container);
      }

      this.getHeaderContainer().css('padding-right', padding);
    },

    getScrollBarWidth: function(el) {
      if (!this._scrollBarWidth) {
        return this._scrollBarWidth = el.offsetWidth - el.clientWidth;
      } else {
        return this._scrollBarWidth;
      }
    },

    getTableContainer: function() {
      return this.$('.e3-table-row-container');
    },

    getHeaderContainer: function() {
      return this.$('.e3-table-header');
    },

    getMinHeaderContainer: function() {
      return this.$('.e3-table-min-header');
    },

    getMinHeaderDropdownToggle: function() {
      return this.getMinHeaderContainer().find('.dropdown-toggle');
    },

    getHeaderCellByName: function(name) {
      return this.$('.e3-table-header-cell[data-name="' + name + '"]');
    },

    getTableRowByIndex: function(index) {
      return this.$('.e3-table-row[data-index="' + index + '"]');
    },

    getTableRowById: function(id) {
      return this.$('.e3-table-row[data-id="' + id + '"]');
    },

    getSelectedTableRows: function() {
      return this.$('.e3-table-row.selected');
    },

    clearSortByName: function(name) {
      var cell = this.getHeaderCellByName(name);
      cell.removeClass('asc-sort').removeClass('desc-sort');
    },

    setAriaSortAttributes: function(cell, ariaSortDirection) {
      cell.parent('tr').find('th[aria-sort]').attr('aria-sort','none');
      cell.attr('aria-sort', ariaSortDirection);
    },

    applySortByName: function(name, direction, columnName) {
      var cell              = this.getHeaderCellByName(name),
          directionClass    = null,
          delegate          = this.getDelegate(),
          ariaSortDirection;

      switch (direction) {
        case delegate.SORT_ASC:
          directionClass = 'asc-sort';
          ariaSortDirection = 'ascending';
          break;
        case delegate.SORT_DESC:
          directionClass = 'desc-sort';
          ariaSortDirection = 'descending';
          break;
      }
      if (directionClass) {
        this.setAriaSortAttributes(cell, ariaSortDirection);
        cell.addClass(directionClass);
      }

      // Apply text on sort dropdown button
      var sortDropdownItem = delegate.getSortDescription(columnName, direction);

      if (sortDropdownItem) {
        this.getMinHeaderDropdownToggle()
          .find('.sort-column-name').text(sortDropdownItem.displayName)
          .end()
          .find('.sort-dir-description').text(sortDropdownItem.description);
      }
    },

    getTableRowBodyById: function(id) {
      return this.$('.e3-table-row-body[data-rowbody-id="' + id + '"]');;
    },

    refreshSelectedItems: function() {
      var delegate    = this.getDelegate(),
          items       = delegate.getSelectedItems(),
          item        = null,
          selected    = this.getSelectedTableRows(),
          len         = items ? items.length : 0,
          foundIndex  = -1,
          selectedIds = [],
          id          = null,
          found       = false,
          j           = 0,
          i           = 0;

      // loop through the selected and verify that they are in
      // the items array
      for (i = 0; i < selected.length; ++i) {
        id = Number(selected.eq(i).data('id'));
        found = false;

        for (j = 0; j < len; ++j) {
          item = items[j];
          if (item.id === id) {
            found = true;
            break;
          }
        }

        if (found === false) {
          this.unselectItem(selected.eq(i), item);
        } else {
          selectedIds.push(id);
        }
      }

      // loops through items and make sure that they are selected
      for (i = 0; i < len; ++i) {
        item = items[i];
        if ((foundIndex = _.indexOf(selectedIds, item.id)) > -1) {
          selectedIds.splice(foundIndex, 1);
        } else {
          this.selectItem(item.id);
        }
      }
    },

    selectItem: function(id) {
      var row = null;

      if (id instanceof $) {
        row = id;
      } else {
        row = this.getTableRowById(id);
      }

      row.addClass('selected');

      var item     = this.getElementDatum(row),
          cells    = row.find('.e3-table-row-cell'),
          selected = cells.filter('.selected'),
          c        = null,
          len      = cells.length,
          i        = 0;

      // loop through the cells and add/remove the appropriate classes
      for (i = 0; i < len; ++i) {
        c = item.cells[i];
        cells.eq(i).removeClass(c.column.original.unselected).addClass(c.column.original.selected);
      }
    },

    unselectItem: function(id) {
      var row = null;

      if (id instanceof $) {
        row = id;
        // this means we have an id instead of a row el
      } else {
        row = this.getTableRowById(id);
      }

      var cells = row.find('.e3-table-row-cell'),
          item  = this.getElementDatum(row),
          c     = null,
          len   = cells.length,
          i     = 0;

      row.removeClass('selected').removeClass('highlight')

      // loop through the cells and add/remove the appropriate classes
      for (i = 0; i < len; ++i) {
        c = item.cells[i];
        cells.eq(i).removeClass(c.column.original.selected).addClass(c.column.original.unselected);
      }
    },

    handleTableHeaderCell: function(ev) {
      var el    = $(ev.currentTarget),
          index = Number(el.data('index'));

      this.getDelegate().columnWasSelectedAtIndex(index);
    },

    getItemFromClick: function(ev) {
      return data = this.getElementDatum(ev.currentTarget);
    },

    handleTableRowClick: function(ev) {
      var data = this.getItemFromClick(ev),
          el   = $(ev.currentTarget);

      if (data) {
        this.getDelegate().toggleItemSelection(data);
      }
    },

    handleRemoveClick: function(ev) {
      var data = this.getItemFromClick(ev);

      ev.stopPropagation();

      if (data) {
        this.getDelegate().removeItem(data);
      }
    },

    handleMinTableHeaderSortEnter: function(ev) {
      if (ev.keyCode == 13) {
        this.handleMinTableHeaderSortClick(ev);
      }
    },

    handleMinTableHeaderSortClick: function(ev) {
     var el = $(ev.currentTarget).closest('li');

     this.getDelegate().setSortDropdownByIndex(el.data('index'));

     el.closest('.dropdown-menu').siblings('.dropdown-toggle').trigger('click');
    }

  });

  var _id = 0;
  var uuid = function() {
    return ++_id;
  };


  var TableController = Vertebrae.Controller.extend({

    properties: [
      'columns',
      'delegate',
      'filter',
      'filteredItems',
      'flags',
      'items',
      'name',
      'newItemSetQueue',
      'options',
      'selectedItems',
      'sort',
      'sortedItems',
      'started'
    ],

    events: {
      'view:ready': null
    },

    SORT_ASC: 1,
    SORT_DESC: 2,

    view: TableView,

    initialize: function(options) {
      this._super();
      this.setSelectedItems([]);
      this.setFlags(this.defaultFlags());
      options = _.defaults(options || {}, this.defaults());
      this.setOptions(options);
      if (this.getOption('name')) {
        this.setName(this.getOption('name'));
      } else {
        this.setName('table');
      }
      this.setColumns(options.columns);
      this.setDelegate(options.delegate);
      this.setItems([]);
      this
          .sync('sort')
          .sync('filter')
          .sync('items')
          .sync('selectedItems')
          .sync('columns');

      this.taskQueue = [];

      this.setNewItemSetQueue([]);
    },

    defaults: function() {
      return {
        columns           : [],
        emptyListTemplate : 'e3.table.empty',
        groupedItemCount  : false,
        groupedItems      : false,
        groupedItemsKey   : false,
        idProperty        : 'id',
        multiSelect       : false,
        name              : 'table',
        // when the data set changes...try and persist
        // the selected items
        persistSelection  : false,
        remoteFilter      : false,
        remoteSort        : false,
        selectable        : true,
        selectedIds       : [],
        sortColumnIndex   : 0,
        theme             : 'default',
        elementId         : false,
        ariaLabel         : '',
        ariaLabelledBy    : '',
        ariaDescribedBy   : ''
      };
    },

    getOption: function(opt) {
      return this.getOptions()[opt];
    },

    defaultFlags: function() {
      return {
        appendNewData: false,
        refreshing: false,
        forceRenderAll: false
      };
    },

    setFlag: function(flag, value) {
      this.getFlags()[flag] = value;
      return this;
    },

    getFlag: function(flag) {
      return this.getFlags()[flag];
    },

    getSelectedItem: function() {
      return this.getSelectedItems()[0];
    },

    addTask: function(fn, options) {
      this.taskQueue.push({ fn: fn, options: options || {} });
      return this.activity();
    },

    activity: function() {
      if (this._taskPromise) {
        return this._taskPromise;
      }

      var next = function() {

        var task = this.taskQueue.shift();

        if (task == null) {
          return Promise.resolve();
        }

        if (!task.options.force && this.getTask(task.fn)) {
          return Promise.bind(this).tap(next);
        }

        this._runningTask = true;

        return Promise
            .bind(this)
            .tap(function() {
              if (task.fn) {
                var returnPromise = task.fn.apply(this, task.options.args || []);
                if (returnPromise !== this._taskPromise) {
                  this._activeFn = task.fn;
                  this._activePromise = returnPromise;
                  return returnPromise;
                } else {
                  return Promise.resolve();
                }
              }
            })
            .lastly(function() {
              this._activePromise = null;
              this._activeFn = null;
              this._runningTask = false;
            })
            .tap(next);
      };

      return this._taskPromise = Promise
          .delay(0)
          .bind(this)
          .tap(next)
          .lastly(function() {
            this._taskPromise = null;
          })
          .lastly(this.showLoading());
    },

    getTask: function(fn) {
      return _.findWhere(this.taskQueue, { fn: fn });
    },

    isPending: function() {
      return this.taskQueue.length > 0 || this._runningTask;
    },

    itemsDidChange: function() {
      this.clearAllCaches();
    },

    filterDidChange: function() {
      this.clearPreviousFilterCache();

      if (this.getOption('remoteFilter')) {
        return this.addTask(this.refresh);
      }
      return this.addTask(this.refreshItemsInView);
    },

    sortDidChange: function() {
      this.clearPreviousSortCache();
      if (this.getOption('remoteSort')) {
        return this.addTask(this.refresh);
      }
      return this.addTask(this.refreshItemsInView);
    },

    refreshSortPropertyOnView: function(sort) {
      var view         = this.getView(),
          sortViewName = sort && sort.column ? sort.column.viewName : '';

      if (!sort) { return }

      // if we have a sort direction, apply the sort, otherwise set all the aria-sort directions to "none"
      if (sort.direction) {
        view.applySortByName(sortViewName, sort.direction, sort.column.name);
      } else {
        view.setAriaSortAttributes(view.getHeaderCellByName(sortViewName, 'none'));
      }
    },

    columnsDidChange: function() {
      this.setFlag('forceRenderAll', true);
      // we need to re-process all the items since the columns have changed
      this.processDataFromDelegate(_.pluck(this.getItems(), 'item'));
      return this.refreshItemsInView();
    },

    selectedItemsDidChange: function(selectedItems, oldSelectedItems) {

      return this.addTask(this.groupSelectedItemDiffs, { force: true, args: [oldSelectedItems || []] });
    },

    groupSelectedItemDiffs: function(oldSelectedItems) {
      var task    = this.getTask(this.groupSelectedItemDiffs),
          oldIds  = null,
          added   = null,
          removed = null;

      // this task is set to go in the future.....
      // so we don't want to run it
      if (task) {
        // concat the selected/unselected items together to process later
        task.options.args[0] = oldSelectedItems;
        return;
      }

      if (this.getTask(this._selectItemById) || this.getTask(this._unselectItemById)) {
        this.addTask(this.groupSelectedItemDiffs, { args: [oldSelectedItems] });
        return;
      }

      oldIds       = _.pluck(oldSelectedItems, 'id');
      // we need to take the currently selected items and removed the previously selected
      // we do not want to map the old objects to new objects even if the id is the same
      // because if the objects have the same id but are a difference instance then that means
      // we got new items but we have not selected any of them yet
      addedItems   = _.difference(this.getSelectedItems(), oldSelectedItems);
      // for figuring out the removed items we DO want to map the old selected items
      // to new items by id
      removedItems = _.difference(this.getItemsByIds(oldIds), this.getSelectedItems());

      this.addTask(this.refreshSelectedItemsInView);

      return this.addTask(this.processSelectedItemsDiff, { args: [addedItems, removedItems]});
    },

    processSelectedItemsDiff: function(added, removed) {
      var respondsToSelected   = this.hasDelegateFunction('tableItemWasSelected'),
          respondsToUnselected = this.hasDelegateFunction('tableItemWasUnselected'),
          delegate             = this.getDelegate();

      removed = _.map(removed, function(item) {
        item.selected = false;
        if (respondsToUnselected) {
          return delegate.tableItemWasUnselected(item, this);
        }
      }, this);

      added = _.map(added, function(item) {
        item.selected = true;
        if (respondsToSelected) {
          return delegate.tableItemWasSelected(item, this);
        }
      }, this);

      // add a task to process anything the delegate may want to process about about the selected/unselected
      return this.addTask(function() {
        return Promise.all(_.compact(removed.concat(added)));
      });
    },

    refreshSelectedItemsInView: function() {
      var view = this.getView();

      if (!this.hasStarted()) {
        return;
      }

      if (!view.isAvailable()) {
        this.listenToOnce(view, 'change:available', function() {
          this.addTask(this.refreshSelectedItemsInView);
        });
        return;
      }

      return this.addTask(function() {
        return view.refreshSelectedItems();
      });
    },

    toggleItemSelection: function(item) {
      if (item.selected) {
        this.unselectItem(item);
      } else {
        this.selectItem(item);
      }
    },

    getItemById: function(id) {
      var items = this.getItems(),
          len   = items ? items.length : 0,
          i     = 0;

      for (i = 0; i < len; ++i)  {
        if (items[i] && items[i].id === id) {
          return items[i];
        }
      }

      return null;
    },

    getTableRowById: function(id) {
      return this.getView().getTableRowById(id);
    },

    getItemsByIds: function(ids) {
      var items = [],
          len   = _.isArray(ids) ? ids.length : [],
          item  = null,
          i     = 0;

      for (i = 0; i < len; ++i) {
        item = this.getItemById(ids[i]);
        if (item) {
          items.push(item);
        }
      }
      return items;
    },

    clearSelectedItems: function() {
      this.setSelectedItems([]);
      return this.activity();
    },

    importSelectedItems: function(items) {
      items = _.map(items, this.setupItem, this);

      var currentlySelectedItems = this.getSelectedItems();

      this.setSelectedItems(currentlySelectedItems.concat(items));

      if (this.hasStarted()) {
        this.addTask(this._setupSelectedItems);
      }

      return this;
    },

    selectItemById: function() {
      var ids = arguments,
          len = ids.length,
          i    = 0;

      for (i = 0; i < len; ++i) {
        this.addTask(this._selectItemById, { force: true, args: [ids[i]] })
      }

      return this.activity();
    },

    _selectItemById: function(id) {
      var item = this.getItemById(id);

      if (!item && this.getOption('persistSelection')) {
        item = _.find(this.getFlag('previouslySelectedItems'), function(selected) { return selected.id === id });
      }
      if (item) {
        this.selectItem(item);
      }
    },

    unselectItemById: function() {
      var ids = arguments,
          len = ids.length,
          item = null,
          i    = 0;

      for (i = 0; i < len; ++i) {
        this.addTask(this._unselectItemById, { force: true, args: [ids[i]] })
      }

      return this.activity();
    },

    _unselectItemById: function(id) {
      var item = this.getItemById(id);

      if (!item && this.getOption('persistSelection')) {
        item = _.find(this.getSelectedItems(), function(selected) { return selected.id === id });
      }
      if (item) {
        this.unselectItem(item);
      }
    },

    selectItem: function(item) {
      var items        = this.getSelectedItems(),
          previousItem = null;

      // process item through delegate to make sure we can select it
      if (this.isItemSelectable(item) === false) {
        return;
      }

      previousItem = _.find(items, function(it) { return it.id === item.id });

      if (previousItem) {
        // this item is already in here!!! oh no!
        // I guess we just return.....
        return this.activity();
      }

      if (this.getOption('multiSelect')) {
        this.setSelectedItems(items.concat([item]));
      } else {
        // Make sure the all previous items selected flag is unset
        for (var i = 0, len = items.length; i < len; i++) {
          items[i].selected = false;
        }

        this.setSelectedItems([item]);
      }

      item.selected = true;
      this.trigger('item:select', item);
      return this.activity();
    },

    unselectItem: function(item) {
      var items = this.getSelectedItems();

      if (this.isItemUnselectable(item) === false) {
        return;
      }

      item.selected = false;

      this.setSelectedItems(_.without(items, item));

      this.trigger('item:unselect', item);
    },

    /**
     * Master function to kick everything off
     *
     * In order to render we really just need the column information which should have been passed in
     *
     * @return {Promise}
     */
    start: function() {
      this.setStarted(true);

      // we want to render the entore view
      // so set forceRenderAll to true
      this.setFlag('forceRenderAll', true);

      this._refreshItemsInView();

      return this.addTask(this.refresh);
    },

    hasStarted: function() {
      return !!this.getStarted();
    },

    next: function() {
      // this._appendNewData = true;
      this.setFlag('appendNewData', true);
      return this.addTask(this.refresh)
          .bind(this)
          .lastly(function() {
            this.setFlag('appendNewData', false);
            // this._appendNewData = false;
          });
    },

    refresh: function() {
      if (!this.hasStarted()) {
        return Promise.resolve();
      }

      // add task to refresh items....and we ALWAYS want to refresh items
      // if we are appending new data
      this.addTask(this._refreshItems, { force: this.getFlag('appendNewData') });

      this.setFlag('refreshing', true);

      // add task to refresh items in view
      this.addTask(this.refreshItemsInView, { force: this.getFlag('appendNewData') })
        .bind(this)
        .lastly(function() {
          this.setFlag('refreshing', false);
        });

      return this.activity();
    },

    isRefreshing: function() {
      return !!this.getFlag('refreshing') || !!this.getFlag('refreshing-in-view');
    },

    _setupSelectedItems: function() {
      var selectedItems      = this.getSelectedItems(),
          initialSelectedIds = this.getOption('selectedIds');

      this.setSelectedItems([]);

      this.setFlag('previouslySelectedItems', selectedItems);

      _.each(selectedItems, function(previouslySelected) {
        this.selectItemById(previouslySelected.id);
      }, this);

      if (!this.getFlag('setupInitialIds')) {
        this.setFlag('setupInitialIds', true);

        _.each(initialSelectedIds, function(id) {
          this.selectItemById(id);
        }, this);

        if (this.hasDelegateFunction('getInitiallySelectedIds')) {
          _.each(this.getDelegate().getInitiallySelectedIds(this), function(id) {
            this.selectItemById(id);
          }, this);
        }
      }
    },

    _refreshItems: function() {
      return Promise
          .resolve(this._getItems())
          .bind(this)
          .then(this.processDataFromDelegate);
    },

    processDataFromDelegate: function(items) {
      var items = _.map(items, this.setupItem, this);
      if (this.getFlag('appendNewData')) {
        this.setItems(Array.prototype.concat(this.getItems(), items));
        this.getNewItemSetQueue().push(items);
      } else {
        this.setItems(items);
      }
    },

    refreshItemsInView: function() {
      if (!this.hasStarted()) {
        return Promise.resolve();
      }

      this.setFlag('refreshing-in-view', true);

      this.addTask(this._refreshItemsInView)
          .bind(this)
          .tap(function() {
            this.setFlag('refreshing-in-view', false);
          });

      return this.addTask(this._setupSelectedItems);
    },

    _refreshItemsInView: function() {
      var view = this.getView();

      if (this.getFlag('forceRenderAll')) {
        this.render();
        this.setFlag('forceRenderAll', false);
        if (this.getSort()) {
          this.refreshSortPropertyOnView(this.getSort());
        }
      }

      if (!view.isAvailable()) {
        this.listenToOnce(view, 'change:available', this.refreshItemsInView);
        return;
      }

      return view.refreshItems();
    },

    getTemplateProperties: function() {
      return {
        columns        : this.getColumns(),
        sColumns       : this.getSortableColumns(),
        theme          : this.theme || this.getOption('theme') || 'default',
        elementId      : this.view.cid,
        ariaLabel      : this.getOption('ariaLabel'),
        ariaLabelledBy : this.getOption('ariaLabelledBy'),
        ariaDescribedBy: this.getOption('ariaDescribedBy')
      };
    },

    setupItem: function(model, index, items) {
      var item = {
        cells      : null,
        selected   : false,
        selectable : false,
        index      : index,
        item       : model,
        classes    : '',
        id         : this.getIdFromItem(model)
      };

      item.classes = this.getItemClasses(item);

      return item;
    },

    setupItemForView: function(item) {
      item.cells = this.setupItemCells(item);
      return item;
    },

    setupItemCells: function(item) {
      return _.map(this.getColumns(), function(column) {
        return this.setupItemCell(item, column);
      }, this);
    },

    setupItemCell: function(item, column) {
      var value = this.getItemField(item, column);

      var cell = {
        content   : this.formatItemText(value, column, item),
        value     : value,
        className : column.className,
        value     : value,
        column    : column
      };

      if (this.hasDelegateFunction('processTableItemCell')) {
        cell = this.getDelegate().processTableItemCell(cell, item, column, this);
      }

      return cell;
    },

    formatItemText: function(value, column, item) {
      if (column.original.remove === true) {
        column.original.icon = 'times';
      }

      if (column.original.icon) {
        var icon = column.original.icon;
        var roleAttr, ariaLabel, ariaLabelledBy, ariaDescribedBy;

        if (this.hasDelegateFunction('processItemIcon')) {
          icon = this.getDelegate().processItemIcon(item, icon, this);
        }

        roleAttr = column.original.isIconButton ? ' role="button"' : '';
        ariaLabel = column.original.ariaLabel ? ' aria-label="' + column.original.ariaLabel + '"' : '';
        ariaLabelledBy = column.original.ariaLabelledBy ? ' aria-labelledby="' + column.original.ariaLabelledBy + '"' : '';
        ariaDescribedBy = column.original.ariaDescribedBy ? ' aria-describedby="' + column.original.ariaDescribedBy + '"' : '';

        return new Handlebars.SafeString('<i' + roleAttr + ariaLabel + ariaLabelledBy + ariaDescribedBy + ' class="fa-icon fa-icon-' + String(icon).toLowerCase() + '"></i>');
      }

      if (_.isString(column.original.processItemText)) {

        return new Handlebars.SafeString(this.getDelegate()[column.original.processItemText](value, item.item, column, this));
      } else if (_.isFunction(column.original.processItemText)) {

        return new Handlebars.SafeString(column.original.processItemText.call(this, value, item.item, column, this));
      }

      if (column.original.type) {

        return this.formatItemTextByType(value, String(column.original.type).toLowerCase(), column, item);
      }

      return value;
    },

    getItemField: function(item, column) {
      var model          = item.item;

      //Get the value from an accessor function
      if (column.original.accessor) {
        var accessor = 'get' + Vertebrae.String.camelCase(column.original.accessor);
        if (_.isFunction(model[accessor])) {
          return model[accessor]();
        }
        throw new Error('Could not call acessor "' + column.original.accessor + '"');
      }

      // Get the value from a namespace
      if (column.original.namespace) {
        return Vertebrae.Object.getPropertyByNamespace(model, column.original.namespace);
      }

      // Get the value from a standard property on the object.
      return model[column.name];
    },

    formatItemTextByType: function(value, type, column, item, index) {
      switch (type) {
        case 'date':

          return this._formatDateType(value, column, item.item, index);
        break;
        case 'html':

          return new Handlebars.SafeString(value || '');
        break;
      };

      return value;
    },

    setupColumn: function(column, index, columns) {
      if (column.remove === true) {
        this.setupRemoveColumn(column);
      }

      if (column.icon != null) {
        this.setupIconColumn(column);
      }

      return {
        displayName           : column.displayName || column.name,
        index                 : index,
        sortable              : this.isColumnSortable(column),
        accessor              : column.accessor || null,
        name                  : column.name || column.namespace || 'unknownColumn',
        viewName              : column.name || String(column.namespace).replace(/\./g, '-'),
        width                 : column.width || (100/columns.length) + '%',
        className             : column.isButton ? column.className + ' has-button' : column.className,
        visible               : this.isColumnVisible(column),
        original              : column,
        isButton              : column.isButton,
        accessibleDisplayName : column.accessibleDisplayName
      };
    },

    getSortableColumns: function() {
      var columns  = this.getColumns(),
          sColumns = [],
          column   = null;

      for (var i = 0, len = columns.length; i < len; i++) {
        column = columns[i].original;

        if (column.icon || column.remove) { continue; }

        // todo - as delegate function reference if sorting by
        // a particular type or column field not processed here

        if (column.type == 'html') {
          continue;
        } else if (column.type == 'date') {
          sColumns.push({
            displayName: column.displayName,
            description: 'Oldest to Newest',
            direction: this.SORT_ASC,
            name: column.name || column.namespace
          })
          sColumns.push({
            displayName: column.displayName,
            description: 'Newest to Oldest',
            direction: this.SORT_DESC,
            name: column.name || column.namespace
          })
        } else if (column.type == 'number') {
          sColumns.push({
            displayName: column.displayName,
            description: '0 to 9',
            direction: this.SORT_ASC,
            name: column.name || column.namespace
          })
          sColumns.push({
            displayName: column.displayName,
            description: '9 to 0',
            direction: this.SORT_DESC,
            name: column.name || column.namespace
          })
        } else { // Default to string type
          sColumns.push({
            displayName: column.displayName,
            description: 'A to Z',
            direction: this.SORT_ASC,
            name: column.name || column.namespace
          })
          sColumns.push({
            displayName: column.displayName,
            description: 'Z to A',
            direction: this.SORT_DESC,
            name: column.name || column.namespace
          })
        }
      }

      return sColumns;
    },

    getSortDescription: function(name, direction) {
      return _.findWhere(this.getSortableColumns(), { name: name, direction: direction });
    },

    setSortDropdownByIndex: function(index) {
      var sortDropdownItem = this.getSortableColumns()[index];

      this.setSortByName(sortDropdownItem.name, sortDropdownItem.direction);
    },

    setupRemoveColumn: function(column) {
      column.name = '_removeBtn';
      column.displayName = column.displayName && !column.accessibleDisplayName ? column.displayName : ' ';
      column.sortable = false;
      column.className = column.className ? column.className + ' ' : '';
      column.className += 'remove-icon-cell';
    },

    setupIconColumn: function(column) {
      column.name = '_iconCell';
      column.displayName = column.displayName ? column.displayName : ' ';
      column.sortable = false;
      column.className = column.className ? column.className + ' ' : '';
      column.className += 'icon-cell icon-' + column.icon + '-cell';
    },

    isColumnSortable: function(column) {
      if (column.sortable === false) {

        return false;
      }

      return true;
    },

    isColumnVisible: function(column) {
      if (column.visible === false) {
        return false;
      }
      return true;
    },

    setColumns: function(columns) {
      return this._super(_.map(columns, this.setupColumn, this));
    },

    columnWasSelectedAtIndex: function(index) {
      var column    = this.getColumns()[index],
          sort      = this.getSort(),
          direction = this.SORT_ASC;

      if (sort && column && sort.column.name === column.name) {
        switch (sort.direction) {
          case this.SORT_ASC:
            direction = this.SORT_DESC;
          break;
          case this.SORT_DESC:
            direction = null;
          break;
        };
      }

      if (column) {
        this.setSortByColumn(column, direction);
      }
    },

    setSortByName: function(name, direction) {
      var column = _.findWhere(this.getColumns(), { name: name });

      if (column) {
        this.setSortByColumn(column, direction);
      }
    },

    setSortByColumn: function(column, direction) {
      var sort         = this.getSort(),
          view         = this.getView();

      if (sort && view.isAvailable()) {
        view.clearSortByName(sort.column.viewName);
      }

      if (direction != this.SORT_ASC && direction != this.SORT_DESC) {
        direction = null;
      }

      if (column) {
        this.setSort({
          direction : direction,
          column    : column
        });
      } else {
        this.setSort(null);
      }
    },

    processFilterForItems: function(items) {
      var filter = this.getFilter();

      if (filter && !this.getOption('remoteFilter')) {
        items = this._processFilter(items, filter);
      }

      return items;
    },

    processSortForItems: function(items) {
      var sort = this.getSort();

      if (!this.getOption('remoteSort')) {

        if (sort.direction != null) {
          items = this._processSort(items, sort.column.name, sort.column.original);
        }

        if (sort.direction == this.SORT_DESC) {
          items = items.reverse();
        }
      }

      return items;
    },

    clearAllCaches: function() {
      this.clearPreviousSortCache();
      this.clearPreviousFilterCache();
    },

    clearPreviousSortCache: function() {
      this.setSortedItems(null);
    },

    clearPreviousFilterCache: function() {
      this.setSortedItems(null);
      this.setFilteredItems(null);
    },

    showLoading: function() {
      return this._showLoading();
    },

    hasGroupedItems: function() {
      return this.getOption('groupedItems');
    },

    showGroupedItemsCount: function() {
      return this.getOption('groupedItemCount');
    },

    getGroupedItems: function(items) {

      return this._processGroupedItems(items);
    },

    getProcessedItems: function() {
      var sorted   = this.getSortedItems(),
          sort     = this.getSort(),
          filtered = this.getFilteredItems(),
          filter   = this.getFilter(),
          items    = (this.getNewItemSetQueue().shift() || this.getItems() || []).slice();

      if (filter) {
        if (filtered) {
          items = filtered;
        } else {
          items = this.processFilterForItems(items);
          this.setFilteredItems(items);
        }
      }

      if (sort) {
        if (sorted) {
          items = sorted;
        } else {
          items = this.processSortForItems(items.slice());
          this.setSortedItems(items);
        }
      }

      items = _.map(items, this.setupItemForView, this);

      if (this.hasGroupedItems()) {
        items = this.getGroupedItems(items.slice());
      }

      return items;
    },

    getGroupedItemsByKey: function(items, key) {
      var i     = 0,
          len   = items ? items.length : 0,
          item  = null,
          map   = {},
          group = null,
          value = null,
          array = [];

      key = String(key);

      for (i = 0; i < len; ++i) {
        item = items[i];

        if (key.indexOf('.') > -1) {
          value = Vertebrae.Object.getPropertyByNamespace(item.item, key);
        } else {
          value = item.item[key];
        }

        if (!map[value]) {

          group = {
            name: this._getGroupName(value, key),
            items: [item]
          };

          map[value] = group.items;

          array.push(group);

        } else {
          map[value].push(item);
        }
      }

      return array;
    },

    getIdFromItem: function(item) {
      var idProperty = this.getOption('idProperty'),
          value      = null;

      if (String(idProperty).indexOf('.') > -1) {
        value = Vertebrae.Object.getPropertyByNamespace(item, idProperty);
      } else {
        value = item.hasOwnProperty(idProperty) ? item[idProperty] : null;
      }

      return value == null ? uuid() : value;
    },

    removeItem: function(item) {
      this.addTask(function() {
        if (this.hasDelegateFunction('removeTableItem')) {
          return this.getDelegate().removeTableItem(item, this);
        }
      });
      return this.refresh();
    },

    hasDelegateFunction: function(fnName) {
      if (this.getDelegate()) {
        return _.isFunction(this.getDelegate()[fnName]);
      }
      return false;
    },

    isItemSelectable: function(item) {
      if (this.hasDelegateFunction('isTableItemSelectable')) {
        return this.getDelegate().isTableItemSelectable(item, this);
      }
      return this.getOption('selectable');
    },

    isItemUnselectable: function(item) {
      if (this.hasDelegateFunction('isTableItemUnselectable')) {
        return this.getDelegate().isTableItemUnselectable(item, this);
      }
      return true;
    },

    getItemClasses: function(item) {
      var classList = '';

      if (this.hasDelegateFunction('processItemClasses')) {
        classList = this.getDelegate().processItemClasses(item, this) || '';
      }

      if (this.isItemSelectable(item)) {
        classList += ' clickable';
      }

      // we can add functionality here as we need it....

      return classList;
    },

    _getItems: function() {
      if (this.hasDelegateFunction('getData')) {
        return this.getDelegate().getData(this);
      }
      return this.getOption('items') || [];
    },

    _showLoading: function() {
      if (this.hasDelegateFunction('showLoading')) {
        return this.getDelegate().showLoading();
      }
    },

    _processSort: function(items, name, column) {

      if (this.hasDelegateFunction('processSort')) {
        return this.getDelegate().processSort(items, name, column, this);
      }

      return _.sortBy(items, function(item) {

        return this.getSortValueForRow(item.item, name, column);
      }, this);
    },

    getSortValueForRow: function(item, name, column) {
      if (column.namespace) {

        return String(Vertebrae.Object.getPropertyByNamespace(item, column.namespace)).toUpperCase();
      }

      return String(item[name]).toUpperCase();
    },

    _processFilter: function(items, filter) {
      if (this.hasDelegateFunction('processFilter')) {
        return this.getDelegate().processFilter(items, filter, this);
      }

      return items;
    },

    _processGroupedItems: function(items) {
      var groupedItemsKey = this.getOption('groupedItemsKey'),
          groups          = null;

      if (groupedItemsKey) {
        groups = this.getGroupedItemsByKey(items, groupedItemsKey);
      } else if (this.hasDelegateFunction('processGroupedItems')) {
        groups = this.getDelegate().processGroupedItems(items, this);
      } else {
        groups = [{
          name: 'Group',
          items: items
        }];
      }

      if (this.hasDelegateFunction('processGroupSort')) {
        groups = this.getDelegate().processGroupSort(groups, this);
      } else {
        groups = _.sortBy(groups, function(group) {
          return group.name;
        });
      }

      return groups;
    },

    _getGroupName: function(value, key) {
      if (this.hasDelegateFunction('getGroupName')) {
        return this.getDelegate().getGroupName(value, key, this);
      }
      return value;
    },

    _formatDateType: function(value, column, item, index) {

      return value ? moment(value).format(column.original.format || 'L') : '';
    }

  });


  var AccordionTableView = TableView.extend({

    expandItemBodyById: function(id) {
      var body     = this.getTableRowBodyById(id);

      body.slideDown();

      return Promise.resolve(body.promise())
          .bind(this)
          .then(this.refreshTableScroll);
    },

    collapseItemBodyById: function(id) {
      var body     = this.getTableRowBodyById(id);

      body.slideUp();

      return Promise.resolve(body.promise())
          .bind(this)
          .then(function() {
            body.empty();
            this.refreshTableScroll();
          });
    }

  });


  var AccordianTableController = TableController.extend({

    view: AccordionTableView,

    properties: [
      'itemView',
      'itemTemplate'
    ],

    initialize: function() {
      this._super.apply(this, arguments);
      // we do not allow multiSelect with accordion
      this.getOptions().multiSelect = false;
    },

    processSelectedItemsDiff: function(added, removed) {
      this._super.apply(this, arguments);

      this.addTask(this.expandNewItem, { args: [added[0], removed[0]] });
    },

    expandNewItem: function(added, removed) {
      var view        = this.getView(),
          oldItemView = this.getItemView(),
          newItemView = null,
          body        = [],
          opts        = this.getOptions();

      this.setItemView(null);

      if (added) {
        body = view.getTableRowBodyById(added.id);
        body.hide();

        if (this.isRefreshing() && oldItemView && body.length > 0) {
          newItemView = oldItemView;
          oldItemView = null;
          body.replaceWith(newItemView.$el);
          newItemView.$el.show();
          this.setItemView(newItemView);
        } else if (opts.itemView && body.length > 0) {
        // if we have an itemView then init,setup, and render it
          newItemView = new opts.itemView();
          newItemView.setElement(body);
          newItemView.setDelegate(this.getDelegate());
          this.trigger('itemView:ready', newItemView);
          this.setItemView(newItemView);
        } else if (opts.itemTemplate && body.length > 0) {
          // if we have an itemTemplate then store it on the item template reference property
          this.setItemTemplate({
            body: body,
            template: opts.itemTemplate
          });
        }
      } else if (removed && this.isRefreshing() && oldItemView) {
        // if we are refreshing and we have no added but we have some removed then we 
        // need to replace the removed body with the oldItemView
        body = view.getTableRowBodyById(removed.id);

        if (!_.isEmpty(body)) {
          body.replaceWith(oldItemView.$el);
          oldItemView.$el.show();
        }
      }

      return Promise
          .resolve(this.refreshSelectedItemView())
          .tap(function() {
            return Promise.join(added && view.expandItemBodyById(added.id), removed && view.collapseItemBodyById(removed.id));
          })
          .tap(function() {
            if (oldItemView) {
              // if we have an old view then destroy it
              oldItemView.destroy();
            } else if (removed) {
              // if we have a removed then empty it
              view.getTableRowBodyById(removed.id).empty();
            }
          })
    },

    refreshSelectedItemView: function() {
      if (this.getItemView()) {
        if (this.getItemView().refresh) {
          return this.getItemView().refresh();
        }
        return this.getItemView().render();
      } else if (this.getItemTemplate() && this.getSelectedItem()) {
        var itemTemplate = this.getItemTemplate(),
            view         = this.getView();

        item.body.html(view.template(itemTemplate.template, this.getSelectedItem().item));
      }
    },

    _refreshItemsInView: function() {
      if (this.getItemView()) {
        this.getItemView().$el.detach();
      }
      return this._super.apply(this, arguments);
    }
    
  });


  var TableFactory = Vertebrae.Object.extend({

    properties: [
      'tableContstructor',
      'options'
    ],

    initialize: function(ctor) {
      this.setTableConstructor(ctor);
      this.setOptions({});
      var properties = ctor.prototype.getDefaults();
      _.each(properties, function(no, property) {
        if (this[property]) {
          return;
        }

        this[property] = function(value) {
          this.getOptions()[property] = value;
        };

      }, this);

    },

    create: function(el) {
      var tableContstructor = this.getTableConstructor(),
          table             = tableContstructor(this.getOptions());

      if (!_.isEmpty(el)) {
        table.setup(el);
      }

      return table;
    }

  },
  {

    build: function(ctor) {
      return new this(ctor || TableController);
    }

  });


this["E3Templates"] = this["E3Templates"] || {};
this["E3Templates"]["e3-table"] = this["E3Templates"]["e3-table"] || {};

this["E3Templates"]["e3-table"]["e3.table.empty"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<tr class=\"e3-table-container-empty\"><td colspan="
    + escapeExpression(((helper = (helper = helpers.colspan || (depth0 != null ? depth0.colspan : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"colspan","hash":{},"data":data}) : helper)))
    + "><i>No items</i></td></tr>\n";
},"useData":true});

this["E3Templates"]["e3-table"]["e3.table.init"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "aria-label=\""
    + escapeExpression(((helper = (helper = helpers.ariaLabel || (depth0 != null ? depth0.ariaLabel : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"ariaLabel","hash":{},"data":data}) : helper)))
    + "\"";
},"3":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "aria-labelleby=\""
    + escapeExpression(((helper = (helper = helpers.ariaLabelledBy || (depth0 != null ? depth0.ariaLabelledBy : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"ariaLabelledBy","hash":{},"data":data}) : helper)))
    + "\"";
},"5":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "aria-describedby=\""
    + escapeExpression(((helper = (helper = helpers.ariaDescribedBy || (depth0 != null ? depth0.ariaDescribedBy : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"ariaDescribedBy","hash":{},"data":data}) : helper)))
    + "\"";
},"7":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return escapeExpression(((helper = (helper = helpers.theme || (depth0 != null ? depth0.theme : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"theme","hash":{},"data":data}) : helper)))
    + "-theme";
},"9":function(depth0,helpers,partials,data) {
  var stack1, helper, lambda=this.lambda, escapeExpression=this.escapeExpression, functionType="function", helperMissing=helpers.helperMissing, buffer = "      <th id=\""
    + escapeExpression(lambda(((stack1 = (data && data.root)) && stack1.elementId), depth0))
    + escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"name","hash":{},"data":data}) : helper)))
    + "\"\r\n          class=\"e3-table-header-cell ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.sortable : depth0), {"name":"if","hash":{},"fn":this.program(10, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (data && data.last), {"name":"if","hash":{},"fn":this.program(12, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (data && data.first), {"name":"if","hash":{},"fn":this.program(14, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\"\r\n          scope=\"col\"\r\n          data-index=\""
    + escapeExpression(lambda((data && data.index), depth0))
    + "\"\r\n          data-name=\""
    + escapeExpression(((helper = (helper = helpers.viewName || (depth0 != null ? depth0.viewName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"viewName","hash":{},"data":data}) : helper)))
    + "\"\r\n          style=\"width: "
    + escapeExpression(((helper = (helper = helpers.width || (depth0 != null ? depth0.width : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"width","hash":{},"data":data}) : helper)))
    + ";\"\r\n          title=\""
    + escapeExpression(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"displayName","hash":{},"data":data}) : helper)))
    + "\"\r\n          aria-label=\"";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.dislayName : depth0), {"name":"if","hash":{},"fn":this.program(16, data),"inverse":this.program(18, data),"data":data});
  if (stack1 != null) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.sortable : depth0), {"name":"if","hash":{},"fn":this.program(20, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\"\r\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.sortable : depth0), {"name":"if","hash":{},"fn":this.program(22, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += ">\r\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.displayName : depth0), {"name":"if","hash":{},"fn":this.program(24, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.accessibleDisplayName : depth0), {"name":"if","hash":{},"fn":this.program(26, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\r\n      </th>\r\n";
},"10":function(depth0,helpers,partials,data) {
  return "sortable";
  },"12":function(depth0,helpers,partials,data) {
  return "last";
  },"14":function(depth0,helpers,partials,data) {
  return "first";
  },"16":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return escapeExpression(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"displayName","hash":{},"data":data}) : helper)));
  },"18":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return escapeExpression(((helper = (helper = helpers.accessibleDisplayName || (depth0 != null ? depth0.accessibleDisplayName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"accessibleDisplayName","hash":{},"data":data}) : helper)));
  },"20":function(depth0,helpers,partials,data) {
  return ", sortable";
  },"22":function(depth0,helpers,partials,data) {
  return "aria-sort=\"none\"";
  },"24":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return escapeExpression(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"displayName","hash":{},"data":data}) : helper)))
    + "&nbsp;";
},"26":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<span class=\"accessibility-text\">"
    + escapeExpression(((helper = (helper = helpers.accessibleDisplayName || (depth0 != null ? depth0.accessibleDisplayName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"accessibleDisplayName","hash":{},"data":data}) : helper)))
    + "</span>";
},"28":function(depth0,helpers,partials,data) {
  var helper, lambda=this.lambda, escapeExpression=this.escapeExpression, functionType="function", helperMissing=helpers.helperMissing;
  return "        <li data-index="
    + escapeExpression(lambda((data && data.index), depth0))
    + "><a tabindex=\"-1\"><strong>"
    + escapeExpression(((helper = (helper = helpers.displayName || (depth0 != null ? depth0.displayName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"displayName","hash":{},"data":data}) : helper)))
    + "</strong> - "
    + escapeExpression(((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"description","hash":{},"data":data}) : helper)))
    + "</a></li>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, lambda=this.lambda, buffer = "<table\r\n  id=\""
    + escapeExpression(((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"elementId","hash":{},"data":data}) : helper)))
    + "\"\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.ariaLabel : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.ariaLabelledBy : depth0), {"name":"if","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.ariaDescribedBy : depth0), {"name":"if","hash":{},"fn":this.program(5, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n  class=\"e3-table ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.theme : depth0), {"name":"if","hash":{},"fn":this.program(7, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\">\r\n  <thead>\r\n  <tr class=\"e3-table-header\">\r\n";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.columns : depth0), {"name":"each","hash":{},"fn":this.program(9, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "    <div class=\"clear\"></div>\r\n  </tr>\r\n\r\n  <tr class=\"e3-table-min-header\">\r\n    <th colspan=\""
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.columns : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" class=\"sort-dropdown dropdown\">\r\n      <span id=\""
    + escapeExpression(((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"elementId","hash":{},"data":data}) : helper)))
    + "Sort\" class=\"btn dropdown-toggle\" data-toggle=\"dropdown\" tabindex=\"1\"><span class=\"caret\"></span><strong class=\"sort-column-name\"></strong> - <span class=\"sort-dir-description\"></span></span>\r\n      <ul id=\""
    + escapeExpression(((helper = (helper = helpers.elementId || (depth0 != null ? depth0.elementId : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"elementId","hash":{},"data":data}) : helper)))
    + "SortOptions\" class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dropdownMenu1\">\r\n";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.sColumns : depth0), {"name":"each","hash":{},"fn":this.program(28, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "      </ul>\r\n    </th>\r\n  </tr>\r\n</thead>\r\n\r\n  <tbody class=\"e3-table-row-container\"></tbody>\r\n</table>\r\n";
},"useData":true});

this["E3Templates"]["e3-table"]["e3.table.row"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  return "last";
  },"3":function(depth0,helpers,partials,data) {
  return "first";
  },"5":function(depth0,helpers,partials,data,depths) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, lambda=this.lambda, buffer = "      <td ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.headersAttr : depth0), {"name":"if","hash":{},"fn":this.program(6, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n          class=\"e3-table-row-cell ";
  stack1 = helpers['if'].call(depth0, (data && data.last), {"name":"if","hash":{},"fn":this.program(1, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (data && data.first), {"name":"if","hash":{},"fn":this.program(3, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " "
    + escapeExpression(((helper = (helper = helpers.className || (depth0 != null ? depth0.className : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"className","hash":{},"data":data}) : helper)))
    + " ";
  stack1 = helpers['if'].call(depth0, (depths[1] != null ? depths[1].selected : depths[1]), {"name":"if","hash":{},"fn":this.program(8, data, depths),"inverse":this.program(10, data, depths),"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\"\r\n          data-title=\""
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.column : depth0)) != null ? stack1.displayName : stack1), depth0))
    + "\"\r\n          style=\"width: "
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.column : depth0)) != null ? stack1.width : stack1), depth0))
    + ";\">\r\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 != null ? depth0.column : depth0)) != null ? stack1.isButton : stack1), {"name":"if","hash":{},"fn":this.program(12, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "          ";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.content : depth0), {"name":"if","hash":{},"fn":this.program(15, data, depths),"inverse":this.program(17, data, depths),"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "\r\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 != null ? depth0.column : depth0)) != null ? stack1.isButton : stack1), {"name":"if","hash":{},"fn":this.program(19, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "      </td>\r\n";
},"6":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "headers=\""
    + escapeExpression(((helper = (helper = helpers.headersAttr || (depth0 != null ? depth0.headersAttr : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"headersAttr","hash":{},"data":data}) : helper)))
    + "\"";
},"8":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression;
  return escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.column : depth0)) != null ? stack1.original : stack1)) != null ? stack1.selected : stack1), depth0));
  },"10":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression;
  return escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.column : depth0)) != null ? stack1.original : stack1)) != null ? stack1.unselected : stack1), depth0));
  },"12":function(depth0,helpers,partials,data) {
  var stack1, buffer = "        <div role=\"button\"\r\n             class=\"e3-table-row-cell-button\"\r\n             ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 != null ? depth0.column : depth0)) != null ? stack1.original : stack1)) != null ? stack1.remove : stack1), {"name":"if","hash":{},"fn":this.program(13, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + ">\r\n";
},"13":function(depth0,helpers,partials,data) {
  return "aria-label=\"remove this item\"";
  },"15":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return escapeExpression(((helper = (helper = helpers.content || (depth0 != null ? depth0.content : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"content","hash":{},"data":data}) : helper)));
  },"17":function(depth0,helpers,partials,data) {
  return "&nbsp;";
  },"19":function(depth0,helpers,partials,data) {
  return "        </div>\r\n";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,depths) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<tr class=\"e3-table-row e3-table-row-content ";
  stack1 = helpers['if'].call(depth0, (data && data.last), {"name":"if","hash":{},"fn":this.program(1, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " ";
  stack1 = helpers['if'].call(depth0, (data && data.first), {"name":"if","hash":{},"fn":this.program(3, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += " "
    + escapeExpression(((helper = (helper = helpers.classes || (depth0 != null ? depth0.classes : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"classes","hash":{},"data":data}) : helper)))
    + "\"\r\n    data-index=\""
    + escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"index","hash":{},"data":data}) : helper)))
    + "\"\r\n    data-id=\""
    + escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"id","hash":{},"data":data}) : helper)))
    + "\">\r\n";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.cells : depth0), {"name":"each","hash":{},"fn":this.program(5, data, depths),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</tr>\r\n<tr class=\"e3-table-row-body\"  data-rowbody-id=\""
    + escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"id","hash":{},"data":data}) : helper)))
    + "\"></tr>\r\n";
},"useData":true,"useDepths":true});


  return {
    Controller: TableController,
    View: TableView,
    AccordionController: AccordianTableController,
    AccordionView: AccordionTableView,
    Factory: TableFactory,
    templates: this['E3Templates']['e3-table'],
    version: '0.0.63'
  };

}));

